var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "validate",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2508",
    "data-name": "Groupe 2508",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1283",
    "data-name": "Trac\\xE9 1283",
    d: "M11.79,3.3l1.78-.769.99,1.679L15,4.95l.84.19,1.9.43-.18,1.95-.08.85.56.65,1.29,1.47-1.28,1.48-.56.65.08.849.18,1.951-1.9.43-.84.19-.44.74-.99,1.68-1.78-.771-.8-.34-.79.34-1.78.771-.99-1.671L7,16.05l-.84-.19-1.9-.43.18-1.961.08-.849-.56-.65L2.67,10.5,3.96,9.02l.56-.65-.09-.86L4.25,5.57l1.9-.43.84-.19.44-.741L8.42,2.53,10.2,3.3l.8.341ZM14.4,0,11,1.46,7.6,0,5.71,3.19,2.1,4l.34,3.7L0,10.49l2.44,2.789-.34,3.7,3.61.82L7.6,21,11,19.53l3.4,1.46L16.29,17.8l3.61-.82-.34-3.69L22,10.49,19.56,7.7l.34-3.69L16.29,3.19Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1284",
    "data-name": "Trac\\xE9 1284",
    d: "M9.09,12.25,6.77,9.92,5.29,11.41l3.8,3.81,7.34-7.36L14.95,6.37Z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedOutlined);
export default __webpack_public_path__ + "static/media/VerifiedOutlined.3a3ea77bba71e5322783adff2356a6cd.svg";
export { ForwardRef as ReactComponent };